import React from 'react'

import { LoginTemplate } from '../../templates'

const Login: React.FC = () => {
  return <LoginTemplate />
}

export default Login
